// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiEnrolUrl: 'https://apiconsumer.ewatpa.com',
  claimUrl: 'https://apiclaims.ewatpa.com',
   recaptchaSiteKey: '6Lc4YX4tAAAAAJ8H23io1rGZ5O-YQl4uW2lgVo7c',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
